import type { ImageVersion } from "src/lib/movieinfo/movieinfotypes";

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type ImageProps = {
    image: ImageVersion[] | ImageVersion | string;
    alt: string;
    className?: string;
    sizes?: string;
    loading?: "lazy" | "eager";
};

//#endregion

//#region [Component]
/**
 * DO NOT USE FOR SANITY IMAGES
 * Renders MovieInfo/TMDB/legacy image urls as they are.
 */
export default function Image({ image, alt, sizes, className, loading }: ImageProps) {
    let _alt = alt;
    if (BRAND === "kinodk" && _alt?.startsWith("Bilde fra ")) {
        _alt = _alt.replace("Bilde fra ", "Billede fra ")
    }

    if (Array.isArray(image)) {
        // When receiving an array of image urls, we use the urls as-is
        const srcSet = image.map(i => `${i.url} ${i.width}w`);
        return <img loading={loading} alt={_alt} srcSet={srcSet.join(",")} sizes={sizes} className={className} />;
    }

    const src = typeof image === "string" ? image : image.url;
    return <img loading={loading} alt={_alt} src={src!} className={className} />
}
//#endregion
